import { z } from 'zod';

export const StringFilterConditionsSchema = z.enum(['Equal','NotEqual','Contains','NotContains','StartsWith','NotStartsWith','Empty','NotEmpty']);

export type StringFilterConditionsType = `${z.infer<typeof StringFilterConditionsSchema>}`

export default StringFilterConditionsSchema;
